import type { ImobiliariaStatus } from '@/types';

const STATUS_ALIASES: Record<string, ImobiliariaStatus> = {
  APROVADO: 'APROVADA',
  ATIVA: 'APROVADA',
  BLOQUEADA: 'SUSPENSA',
  BLOQUEADO: 'SUSPENSA',
};

export const normalizeImobiliariaStatus = (value?: string | null): ImobiliariaStatus | null => {
  const raw = (value || '').trim();
  if (!raw) return null;
  const normalized = raw.toUpperCase().replace(/[\s]+/g, '_');
  const valid = ['EM_ANALISE', 'CREDENCIANDO', 'APROVADA', 'REJEITADA', 'SUSPENSA'] as const;
  if ((valid as readonly string[]).includes(normalized)) {
    return normalized as ImobiliariaStatus;
  }
  return STATUS_ALIASES[normalized] || null;
};

export const resolveImobiliariaStatus = (value?: string | null, active?: boolean | null): ImobiliariaStatus => {
  const normalized = normalizeImobiliariaStatus(value);
  if (normalized) return normalized;
  if (active === false) return 'SUSPENSA';
  return 'EM_ANALISE';
};
